import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import classes from './SkeletonLoader.module.sass'
import { useSelector } from 'react-redux'
import { selectDarkTheme } from '../../../store/slices/settingsSlice'

type Props = {
  count: number
  height?: number | string
  width?: number | string
  style?: React.CSSProperties
  className?: string
}

export const SkeletonLoader = ({ count, height, width, style, className }: Props) => {
  const darkTheme = useSelector(selectDarkTheme)

  return (
    <Skeleton
      inline
      count={count}
      height={height}
      width={width}
      style={style}
      className={className ? classes[className] : ''}
      baseColor={darkTheme ? '#2a2a2a' : '#ebebeb'}
      highlightColor={darkTheme ? '#3a3a3a' : '#f5f5f5'}
    />
  )
}
